import { render, staticRenderFns } from "./id-ID.vue?vue&type=template&id=77398f08&"
import script from "./id-ID.vue?vue&type=script&lang=js&"
export * from "./id-ID.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77398f08')) {
      api.createRecord('77398f08', component.options)
    } else {
      api.reload('77398f08', component.options)
    }
    module.hot.accept("./id-ID.vue?vue&type=template&id=77398f08&", function () {
      api.rerender('77398f08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/Languages/id-ID.vue"
export default component.exports